import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { DataGridPro } from '@mui/x-data-grid-pro'
import { Form, InputGroup } from "react-bootstrap"; 
import * as Admin from "../../../store/ducks/admin.duck";
import { Grid, Paper } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';



export default function ProviderStatistics() {

  const dispatch = useDispatch()
  useEffect( () => { dispatch(Admin.actions.fetchProviderStatistics()) }, [dispatch] )
  const [searchTerm, setSearchTerm] = useState('')
  const providerStatistics = useSelector(state => state.admin.ProviderStatistics)
  const filters = useSelector(state => state.admin.Filters)

  const searchProviderStatistic = (provider) => {
    if( true
        && ((provider.fullName && provider.fullName.toLowerCase().search(searchTerm.toLowerCase()) > -1) || (searchTerm.length === 0))
        && (filters.providerStatisticsRecentBookings === 'All' || (filters.providerStatisticsRecentBookings === 'Recent' && (provider.noBookingsin12Months === '' || provider.noBookingsin12Months === '0')) || (filters.providerStatisticsRecentBookings === 'NotRecent' && provider.noBookingsin12Months === '1')) 
        && (filters.providerStatisticsStatus === 'All' || (filters.providerStatisticsStatus === 'Active' && (provider.archivedProvider === '' || provider.archivedProvider === '0')) || (filters.providerStatisticsStatus === 'InActive' && provider.archivedProvider === '1')) 
      )
    {
      return provider
    }  
  }
  const filteredProviderStatistics = providerStatistics.filter(providerStatistic => searchProviderStatistic(providerStatistic))


  const columns = [
    { field: 'id', headerName: 'ID', width: 100,  hide: true },
    { field: 'fullName', headerName: 'Name', width: 200 },
    { field: 'email', headerName: 'Email', width: 300 },
    { field: 'activeClients', headerName: 'AC', type: 'number', width: 100 },
    { field: 'upcomingBookings', headerName: 'UB', type: 'number', width: 100 },
    { field: 'bookingsOverPast30Days', headerName: 'BP30', type: 'number', width: 100 },
    { field: 'cancellationPercentagePast30Days', headerName: 'CP30', type: 'number', width: 100 },
    { field: 'bulkBilledRatioOverPast30Days', headerName: 'BB', type: 'number', width: 100 },
    { field: 'averageNumberSessionsPerClient', headerName: 'AV', type: 'number', width: 100 },
    { field: 'averageNumberRHCSessionsPerClient', headerName: 'RHC Av', type: 'number', width: 150 },
    { field: 'averageNumberRHCSessionsPerClientNoGP', headerName: 'RHC AvNGP', type: 'number', width: 150 },
    { field: 'totalSessionsDeliveredViaRHC', headerName: 'SD', type: 'number', width: 100 },
    { field: 'totalBulkBilledSessions', headerName: 'TBB', type: 'number', width: 100 },
    { field: 'availabilitySlotsNext30Days', headerName: 'AS30', type: 'number', width: 100 }
  ];


  const handleSearch = (event) => {
    const searchTerm = event.target.value    
    setSearchTerm(searchTerm)
  }


  return (
    <>
      <Grid container direction="row" justifyContent="space-between">
        <Grid item><h4 style={{ marginBottom: 12 }}>Provider Statistics</h4></Grid>
      </Grid>

    <Alert severity="info" variant="light" style={{ backgroundColor: "#DAF3F4", borderColor: "#CEE6E7", marginBottom: 15 }}>
          <AlertTitle>Column Headings:</AlertTitle>
          <ul>
            <li>
              <p>AC - Active Clients</p>
            </li>
            <li>
              <p>UB - Upcoming Bookings</p>
            </li>
            <li>
              <p>BP30 - Bookings Over Past 30 Days</p>
            </li>
            <li>
              <p>CP30 - Cancellation % Over Past 30 Days</p>
            </li>
            <li>
              <p>BB - Bulk Billed Percentage Over Past 30 Days</p>
            </li>
            <li>
              <p>AV - Average Number of Sessions Per Client</p>
            </li>
            <li>
              <p>RHC Av - Average Number RHC Sessions Per Client</p>
            </li>
            <li>
              <p>RHC AvNGP - Average Number RHC Sessions Per Client not including GP Bookings</p>
            </li>
            <li>
              <p>SD - Total Sessions Delivered via RHC</p>
            </li>
            <li>
              <p>TBB - Total Bulk Billed Sessions</p>   
            </li>      
            <li>
              <p>AS30 - Availability Slots Next 30 Days</p>
            </li>
          </ul>  
        </Alert>
    

      <Paper> 
        <Grid container style={{ padding: 15 }}>
          <Grid item style={{ marginTop: 2, marginLeft: 10 }}>
            <InputGroup size="sm" >
              <InputGroup.Prepend>
                <InputGroup.Text>
                  <SearchIcon fontSize="small" style={{ marginLeft: -4 }} />
                </InputGroup.Text>
              </InputGroup.Prepend>
              <Form.Control                  
                  type="text"
                  value={searchTerm}
                  onChange={(event) => handleSearch(event)}
                  autoComplete='OFF'
                />
              </InputGroup>
          </Grid>
          <Grid item style={{ marginRight: 15, marginLeft: 10 }}>  
            <Form.Control as="select" size="sm" style={{ height: 35 }} defaultValue={filters.providerStatisticsStatus} onChange={(event) => dispatch(Admin.actions.setFilters({ filterName: 'providerStatisticsStatus', filterValue: event.target.value }))}>
              <option value="All">All</option>
              <option value="Active">Active</option>
              <option value="InActive">InActive</option>
            </Form.Control>
          </Grid>
          <Grid item style={{ marginRight: 15 }}>  
            <Form.Control as="select" size="sm" style={{ height: 35 }} defaultValue={filters.providerStatisticsRecentBookings} onChange={(event) => dispatch(Admin.actions.setFilters({ filterName: 'providerStatisticsRecentBookings', filterValue: event.target.value }))}>
              <option value="All">All</option>
              <option value="Recent">Recent Only</option>
              <option value="NotRecent">Not Recent Only</option>
            </Form.Control>              
          </Grid>
        </Grid>
      </Paper>

      { providerStatistics ? 
        <Paper style={{ height: 700 }}>
          <DataGridPro rows={filteredProviderStatistics} columns={columns} pageSize={10} checkboxSelection={false} rowHeight={40} />
        </Paper>
      : ('None')
      }

    </>
  )
}
